module.exports = "<p>\n  public works!\n</p>\n"